module.exports = __webpack_public_path__ + "static/img/img-2.94e46d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/img-2.png
// module id = pOvA
// module chunks = 63